import {
  FloatingSection,
  Header,
  Intro,
  NewsWidget,
  SmartLink,
} from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";

const KitchenVisualizer: React.FC = () => {
  return (
    <div>
      <Header
        title={t(routes.visualiser, "title")}
        image={t(routes.visualiser, "image")}
        bgColor="black"
        className="text-white"
      >
        <p>
          We understand that the task of visualising the perfect kitchen whilst
          looking at swatches of colours and texture can be tricky. The kitchen
          visualiser is the perfect solution, allowing you to create a visual
          mood board, with the ability to change doors, worktops and handles in
          four different kitchen styles.
        </p>
        <p>
          The kitchen visualiser has a large selection of the Paula Rosa
          Manhattan ranges, allowing you to find the right look and feel for any
          kitchen theme.
        </p>
        <SmartLink
          to="https://visualiser.prmf.co.uk"
          className="button-accent !mt-12 ml-0"
        >
          Launch visualiser
        </SmartLink>
      </Header>
      <Intro title="Let your vision come to life" bgColor="black" />
      <FloatingSection reverse image="/media/assets/visualizer-features.jpg">
        <ul className="space-y-10 py-20 [&_h3]:font-bold">
          <li>
            <h3>Step 1</h3>
            <p>
              Enter your email address to save your kitchen designs to the
              Cloud, or enter as a guest to save it locally to your browser.
            </p>
          </li>
          <li>
            <h3>Step 2</h3>
            <p>
              Choose from four different kitchen styles – Contemporary, Shaker,
              Integrated Handle, or Linear.
            </p>
          </li>
          <li>
            <h3>Step 3</h3>
            <p>
              Customise your kitchen by adjusting the doors, worktops and
              handles with a selection of Paula Rosa Manhattan products.
            </p>
          </li>
          <li>
            <h3>Step 4</h3>
            <p>
              Create a list of your favourite designs and save for later. You
              can also email and print your design configurations.
            </p>
          </li>
        </ul>
      </FloatingSection>
      <NewsWidget />
    </div>
  );
};

export default KitchenVisualizer;
